<template>
  <div class="w-100 h-100 position-relative">
    <div class="w-100 h-100 map-locked-container"/>
    <VMap
        class="w-100 h-100 map-container"
        :zoom.sync="zoom"
        :previewMode="true"
        :rideMarkers="getStopsList"
        @leaflet-ready="onLeafletReady"
        @updateZoom="updateZoom"
    >
    </VMap>
  </div>
</template>

<script lang="ts">
export default {
  name: 'RideMap',
};
</script>

<script setup lang="ts">
import { ref } from 'vue';
import VMap from '@slg/web-customer-shared/src/components/bookingForm/directionSelection/vMap/VMap.vue';
import * as L from 'leaflet';

const props = defineProps({
  getStopsList: {
    type: Array,
    default: () => [],
  },
});

const zoom = ref(0);
const leafletMap = ref(null);

function updateZoom(e: number) {
  zoom.value = e;
}

function dotsBound() {
  if (!leafletMap.value) {
    return;
  }
  const stopsList = (props.getStopsList as Array<{ lat: number; lon: number }>)
    .filter((marker) => marker?.lat && marker?.lon)
    .map((marker) => L.marker([marker.lat, marker.lon]));
  if (!stopsList.length) {
    return;
  }
  const group = new L.featureGroup(stopsList);
  leafletMap.value.fitBounds(group.getBounds().pad(0.15));
}

function onLeafletReady(mapInstance) {
  leafletMap.value = mapInstance;
  dotsBound();
}
</script>

<style scoped lang="scss">
.map-container {
  position: relative;
  z-index: 1;
}

.map-locked-container {
  position: absolute;
  z-index: 2;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
</style>
